export enum QuestionType {
  Placeholder = 'Placeholder',
  QuestionComboLock = 'QuestionComboLock',
  QuestionDragAndDrop = 'QuestionDragAndDrop',
  QuestionFillInTheBlanks = 'QuestionFillInTheBlanks',
  QuestionFlipboard = 'QuestionFlipboard',
  QuestionMultipleChoiceDropdown = 'QuestionMultipleChoiceDropdown',
  QuestionMultipleChoiceImageMultiple = 'QuestionMultipleChoiceImageMultiple',
  QuestionMultipleChoiceImageSingle = 'QuestionMultipleChoiceImageSingle',
  QuestionMultipleChoiceMultiple = 'QuestionMultipleChoiceMultiple',
  QuestionMultipleChoiceSingle = 'QuestionMultipleChoiceSingle',
  QuestionSlider = 'QuestionSlider',
}
